module.exports = __webpack_public_path__ + "img/semirigido_sx.c02cf1c4.png";